import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, message, Popconfirm} from 'antd';
import {Route, Switch} from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import {
  createResource,
  deleteResource,
  fetchResource,
  getAllUOM,
  getJobCardData,
  getLocationByQuery,
  getQuantity,
  getResource,
  getResourceForDownload,
  saveResourceQuery,
  updateResource,
} from "../../appRedux/actions/SparesIssue";
import {getSpareInventoryBalance} from "../../appRedux/actions/SpareInventoryReport";
import {fetchFilter} from '../../appRedux/actions';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import * as _ from 'lodash';

export class SparesIssue extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: []
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    this.fetchList();
    this.props.fetchFilter(this.props.resourceName);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({visibleColumns: columns}, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
  }

  handleColumnChange = (value, array) => {
    const {filters} = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = {...this.props.query};
    if(data.filterField === 'location') {
      query.filters[data.filterField] = JSON.stringify({
        value: selectedKeys,
        type: data.type,
        field: data.filterField,
      });
    }
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = {...this.props.query};
    if(data && data.filterField && data.filterField === 'location') {
      delete query.filters[data.filterField];
    }
    else {
      delete query.filters[data.field];
    }
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = {...this.props.query};
    query.pagination = {...query.pagination, current: pagination.current};
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const {resourceName} = this.props;

    Object.keys(filters).forEach((item) => {

      if(item === '_id') {
        return;
      }

      if(selectedColumns.indexOf(item) === -1) {
        return;
      }

      columns.push(
        {
          title: sanitizeFieldName(item),
          dataIndex: filters[item].field,
          sorter: true,
          render: (value) => getRenderForFieldByType(value, filters[item].type, item),
          ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
        }
      )
    });

    if(selectedColumns.indexOf("location") >= 0) {
      columns.push({
          title: sanitizeFieldName('location'),
          dataIndex: 'jobCard.location.name',
          key: 'location',
          sorter: true,
          render: (value) => getRenderForFieldByType(value, 'String'),
          ...getColumnSearchProps({
            field: 'name',
            type: 'String',
            filterField: 'location'
          }, this.handleFilter, this.handleReset, 'Location'),
        }
      );
    }

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record) => (
        <div>
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button type="primary" size='small' onClick={() => this.edit(record._id)}>View</Button>
          }}/>

          <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={() => {
                this.deleteResource(record._id)
              }}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button style={{marginLeft: '10px'}} type="danger" size='small'>Delete</Button>
            </Popconfirm>
          }}/>

        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  fetchList = () => {
    this.props.getResource();
  };

  createResource = (values) => {
    this.props.createResource(values);
  };

  updateResource = (values, id) => {
    this.props.updateResource(values, id);
  };

  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled')
  };

  create = () => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = (id) => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  getLocationByQuery = (location) => {
    this.props.getLocationByQuery(location);
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "SparesIssue");
  }

  render() {
    const {match, data, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName, allLocation, jobCardData, spareNameData, searchedData, uomData} = this.props;
    const {columns, visibleColumns} = this.state;
    faviconDynamicFunction(authUser);
    return (<div>
      <h2>{sanitizeFieldName(resourceName)}</h2>

      <Switch>
        <Route path={`${match.url}`} exact
               render={() => <List columns={columns}
                                   visibleColumn={visibleColumns}
                                   data={data}
                                   clearFilter={this.clearAll}
                                   filters={filters}
                                   handleChange={this.handleChange}
                                   columnChange={this.handleColumnChange}
                                   downloadToCSV={this.downloadToCSV}
                                   title={resourceName}
                                   size={'middle'}
                                   create={this.create}
                                   pagination={this.props.query.pagination}
                                   loading={loading}
                                   authUser={authUser}
               />
               }/>
        <Route path={`${match.url}/add`}
               render={(props) => <Create data={{}}
                                          filters={filters}
                                          spareQty={this.props.spareQty}
                                          balance={this.props.balance}
                                          modules={modules}
                                          title={'CREATE'}
                                          resource={resourceName}
                                          allLocation={allLocation}
                                          jobCardData={jobCardData}
                                          getAllUOM={this.props.getAllUOM}
                                          uomData={uomData}
                                          getQuantity={this.props.getQuantity}
                                          getSpareInventoryBalance={this.props.getSpareInventoryBalance}
                                          spareNameData={spareNameData}
                                          searchedData={searchedData}
                                          getLocationByQuery={this.getLocationByQuery}
                                          getJobCardData={this.props.getJobCardData}
                                          onChange={this.handleFormChange}
                                          onSubmit={this.createResource}
                                          loading={loading}
                                          {...props}
               />
               }/>
        <Route path={`${match.url}/edit/:id`}
               render={(props) => <Create data={edit}
                                          filters={filters}
                                          modules={modules}
                                          title={'EDIT'}
                                          allLocation={allLocation}
                                          getAllUOM={this.props.getAllUOM}
                                          uomData={uomData}
                                          jobCardData={jobCardData}
                                          searchedData={searchedData}
                                          getLocationByQuery={this.getLocationByQuery}
                                          getJobCardData={this.getJobCardData}
                                          resource={resourceName}
                                          fetch={fetchResource}
                                          onChange={this.handleFormChange}
                                          onSubmit={this.updateResource}
                                          loading={loading}
                                          {...props}
               />
               }/>
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({auth, sparesIssue, commonData, spareInventory}) => {
  return {
    authUser: auth.authUser,
    total: sparesIssue.total,
    data: sparesIssue.resources,
    resource: sparesIssue.resource,
    edit: sparesIssue.edit,
    query: sparesIssue.query,
    allLocation: sparesIssue.location,
    jobCardData: sparesIssue.jobCard,
    spareNameData: sparesIssue.spareName,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    searchedData: commonData.relationshipSearch,
    uomData: sparesIssue.uomData,
    spareQty: sparesIssue.spareQty,
    balance: spareInventory.balance,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    getQuantity,
    updateResource,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    getLocationByQuery,
    getJobCardData,
    getAllUOM,
    getSpareInventoryBalance,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(SparesIssue);
